var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_25350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11.8543C21 14.784 18.6172 17.1668 15.6875 17.1668H4.91587L7.14429 19.3953C7.28242 19.5334 7.28242 19.7579 7.14429 19.8961C7.07488 19.9655 6.98421 19.9995 6.89354 19.9995C6.80288 19.9995 6.71221 19.9648 6.64279 19.8961L4.31096 17.5642C3.89658 17.1498 3.89658 16.4762 4.31096 16.0618L6.6435 13.7293C6.78163 13.5912 7.00617 13.5912 7.14429 13.7293C7.28242 13.8674 7.28242 14.092 7.14429 14.2301L4.91587 16.4585H15.6875C18.2262 16.4585 20.2917 14.393 20.2917 11.8543C20.2917 11.6588 20.4503 11.5002 20.6458 11.5002C20.8413 11.5002 21 11.6588 21 11.8543ZM4.35417 11.5002C4.54967 11.5002 4.70833 11.3415 4.70833 11.146C4.70833 8.60734 6.77383 6.54184 9.3125 6.54184H20.0841L17.8557 8.77026C17.7176 8.90839 17.7176 9.13293 17.8557 9.27105C17.9251 9.34047 18.0158 9.37447 18.1065 9.37447C18.1971 9.37447 18.2878 9.33976 18.3572 9.27105L20.6898 6.93851C21.1041 6.52414 21.1041 5.85051 20.6898 5.43614L18.3565 3.10359C18.2184 2.96547 17.9938 2.96547 17.8557 3.10359C17.7176 3.24172 17.7176 3.46626 17.8557 3.60439L20.0841 5.8328H9.3125C6.38283 5.83351 4 8.21634 4 11.146C4 11.3415 4.15867 11.5002 4.35417 11.5002Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_25350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.196624e0fb1b7509cfad116950c4c8cf.svg";
export { ForwardRef as ReactComponent };